// Phase 6c — billing READ data layer over the JSON API (/api/billing/*). The WRITE
// flows (checkout/portal/topup) are NOT here: they 303-redirect a top-level browser
// nav to a PSP, which fetch() can't follow — see components/BillingForm.tsx.

import { api } from './api'
import type { CheckoutReturn, InvoicesPage, PlansResponse, BillingState, TopupsResponse } from './types'

/** GET /api/billing/plans — PUBLIC pricing matrix (renders pre-login too). */
export function fetchPlans(): Promise<PlansResponse> {
  return api<PlansResponse>('/api/billing/plans')
}

/** GET /api/billing/state — balance + (optional) subscription. */
export function fetchBillingState(): Promise<BillingState> {
  return api<BillingState>('/api/billing/state')
}

/** GET /api/billing/topups — one-time top-up bundles. */
export function fetchTopups(): Promise<TopupsResponse> {
  return api<TopupsResponse>('/api/billing/topups')
}

/** GET /api/billing/invoices — recent charges, newest-first, paged. */
export function fetchInvoices(opts: { limit?: number; offset?: number } = {}): Promise<InvoicesPage> {
  const params = new URLSearchParams()
  if (opts.limit != null) params.set('limit', String(opts.limit))
  if (opts.offset != null) params.set('offset', String(opts.offset))
  const qs = params.toString()
  return api<InvoicesPage>('/api/billing/invoices' + (qs ? '?' + qs : ''))
}

/** Confirm one Stripe return against the signed-in account's payment + ledger rows. */
export function fetchCheckoutReturn(sessionId: string): Promise<CheckoutReturn> {
  const params = new URLSearchParams({ session_id: sessionId })
  return api<CheckoutReturn>(`/api/billing/checkout-return?${params.toString()}`)
}
